import { IDynamicObject, setNumber } from "xa-generics";

/**
 * ## CourierIncomeModel
 *
 * The income aggregation of a courier close, as the LCT backend's CourierSummary produces it.
 *
 * The buckets are not a fixed list: a restaurant may define payment methods of its own, and the
 * backend seeds a bucket for every one of them. So the values are kept in a dictionary instead of
 * declared fields, and #get answers 0 for a bucket this restaurant happens not to have.
 */
export class CourierIncomeModel {
    constructor(data?: IDynamicObject<any>) {
        if (!data) return;

        for (let key in data) {
            this.values[key] = setNumber(data[key]);
        }
    }

    values: IDynamicObject<number> = {};

    public get(key: string): number {
        return this.values[key] || 0;
    }
}
